import { Icon, type IconProps } from './Icon';

/** Application server: two stacked units with status lights. */
export function ServerIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <rect x="3" y="4" width="18" height="7" rx="1.5" />
      <rect x="3" y="13" width="18" height="7" rx="1.5" />
      <path d="M7 7.5h.01M7 16.5h.01" />
      <path d="M11 7.5h6M11 16.5h6" />
    </Icon>
  );
}
